import { render, staticRenderFns } from "./SetToken.vue?vue&type=template&id=59f4ebf3"
import script from "./SetToken.vue?vue&type=script&lang=js"
export * from "./SetToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports